import React, { useState, useEffect } from "react";
import "./style.css";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { getToken } from '../../authetication/loginState';
import downArrow from "../../assets/icons/downArrow.svg";
import { Select, MenuItem } from '@material-ui/core'
import NoraPDFUploader from "../../components/NoraPDFReport";
import Box from '@mui/material/Box';
import Modal from "@material-ui/core/Modal";
import { useMediaQuery } from '@mui/material';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import overviewIcon from "../../images/overview.png";
import technicalSkillsIcon from "../../images/technicalSkills.png";
import softSkillsIcon from "../../images/softSkills.png";
import transcriptsIcon from "../../images/transcripts.png";
import tldrIcon from "../../images/tldr.png";
import nextStepsIcon from "../../images/nextSteps.png";
import downloadReportIcon from "../../images/downloadReport.png";

const ScoreCard = ({ title, score, subtitle, details, description }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="mock-scorecard" onClick={() => setExpanded(!expanded)}>
      <div className="mock-scorecard-header">
        <div className="mock-scorecard-title-row">
          <span className="mock-scorecard-title">{title}</span>
          <span className="mock-scorecard-badge">{score ?? '—'}/100</span>
          <span className="mock-scorecard-toggle">
            {expanded ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
          </span>
        </div>
        <div className="mock-scorecard-subtitle">{subtitle}</div>
      </div>
      {expanded && (
        <div className="mock-scorecard-body">
          {details && details.length > 0 && (
            <div className="mock-scorecard-details">
              {details.map((d, i) => (
                <div key={i} className="mock-scorecard-detail-row">
                  <span className="mock-scorecard-detail-label">{d.label}</span>
                  <span className="mock-scorecard-detail-value">{d.value}</span>
                </div>
              ))}
            </div>
          )}
          {description && <div className="mock-scorecard-description">{description}</div>}
        </div>
      )}
    </div>
  );
};

const MockInterviewerFeedback = () => {
  const location = useLocation();
  const { aiResponse, history, timerFeedback, technicalLevel, fromInputScreen, recordingRoomName, audioRecordingUrl: initialRecordingUrl } = location.state || {};
  const [audioRecordingUrl, setAudioRecordingUrl] = useState(initialRecordingUrl || null);
  const [recordingLoading, setRecordingLoading] = useState(!!recordingRoomName);

  const [activeSection, setActiveSection] = useState("overview");
  const historyMessage = fromInputScreen
    ? JSON.parse(history)
    : history;

  const jsonString = aiResponse.replace(/```json\n|\n```/g, '');
  const feedbackJson = JSON.parse(jsonString);
  const companyRecsJson = feedbackJson?.companyRecs;
  const similarPositionJson = feedbackJson?.similarPosition;
  const [filter, setFilter] = useState("transcript");
  const isSalaryNegotiation = technicalLevel == 15;
  const [selectedTags, setSelectedTags] = useState([]);
  const [chatMessages, setChatMessages] = useState({}); // Store chat history per tag
  const [chatInput, setChatInput] = useState({});       // Store input text per tag
  const [loadingChat, setLoadingChat] = useState([]);   // Track loading states per tag
  const [showAskNoraModal, setShowAskNoraModal] = useState(false);
  const [noraQuestion, setNoraQuestion] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [interviewTimeline, setInterviewTimeline] = useState('');
  const [personalizedPlan, setPersonalizedPlan] = useState('');
  const [isGeneratingPlan, setIsGeneratingPlan] = useState(false);
  const [showGamePlan, setShowGamePlan] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isCheckingSubscription, setIsCheckingSubscription] = useState(true);
  const [openTest, setOpenTest] = useState(false);
  const [stripeLoaded, setStripeLoaded] = useState(false);
  const [checkout, setCheckout] = useState(null);
  const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
  const [checkoutError, setCheckoutError] = useState('');
  const [selectedPlan, setSelectedPlan] = useState('annual');
  const [paymentProcessing, setPaymentProcessing] = useState(false);

  const [isSharing, setIsSharing] = useState(false);
  const [shareInitiated, setShareInitiated] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);
  const [firstFeedbackUnlocked, setFirstFeedbackUnlocked] = useState(false);

  useEffect(() => {
    if (!recordingRoomName) return;
    const interval = setInterval(async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_ENDPOINT}/api/Daily/recordingStatus?roomName=${recordingRoomName}`,
          { headers: { Authorization: `Bearer ${getToken()}` } }
        );
        if (res.data.ready) {
          console.log('Recording ready:', res.data.url);
          setAudioRecordingUrl(res.data.url);
          setRecordingLoading(false);
          clearInterval(interval);
        }
      } catch {}
    }, 5000);
    return () => clearInterval(interval);
  }, [recordingRoomName]);

  const isMobile = useMediaQuery('(max-width:768px)');

  const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: isMobile ? "90vw" : "80vw",
    height: isMobile ? "85vh" : "90vh", 
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    borderRadius: "10px",
    textAlign: 'center',
    overflow: "scroll",
    p: 4,
  };

  const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

  const isReferred = localStorage.getItem("userReferred") === "true";

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/';
    script.async = true;
    script.onload = () => {
      if (window.Stripe) {
        setStripeLoaded(true);
      }
    };
    script.onerror = () => {
      console.error('Failed to load Stripe.js');
      setCheckoutError('Failed to load payment system. Please refresh the page.');
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    return () => {
      if (checkout) {
        try {
          checkout.destroy();
        } catch (error) {
          console.warn('Error destroying checkout on cleanup:', error);
        }
      }
    };
  }, [checkout]);

  const initializeEmbeddedCheckout = async (plan) => {
    if (!stripeLoaded || !window.Stripe) {
      console.error('Stripe not loaded yet');
      setCheckoutError('Stripe is still loading. Please try again in a moment.');
      return;
    }
    if (!stripePublishableKey) {
      console.error('Missing publishable Stripe key');
      setCheckoutError('Payment configuration is incomplete. Please contact support.');
      return;
    }

    try {
      setCheckoutError('');
      setIsCheckoutLoading(true);

      const userEmail = localStorage.getItem('userEmail') || localStorage.getItem('email');
      if (!userEmail) throw new Error('Missing user email for checkout session.');

      const stripe = window.Stripe(stripePublishableKey);

      const fetchClientSecret = async () => {
        const priceId = plan === 'annual'
          ? ('price_1S8GAZ007XiUv8ECfnqj7tsI')
          : ('price_1PtG3P007XiUv8ECG0fSdL6h');
        const payload = { email: userEmail, priceId };
        
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/payments/create-embedded-checkout-session`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify(payload),
          }
        );
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }
        
        const responseData = await response.json();
        const { clientSecret } = responseData;
        
        if (!clientSecret) {
          throw new Error('No clientSecret received from backend');
        }
        
        return clientSecret;
      };

      const embeddedCheckout = await stripe.initEmbeddedCheckout({ 
        fetchClientSecret,
        onComplete: () => {
          // Payment completed, start checking subscription immediately
          setTimeout(() => {
            checkSubscriptionAfterPayment();
          }, 2000); // Wait 2 seconds then start checking
        }
      });
      embeddedCheckout.mount('#checkout');
      setCheckout(embeddedCheckout);
    } catch (error) {
      console.error('Error initializing embedded checkout:', error);
      setCheckoutError('We could not start the payment flow. Please try again or contact support.');
    } finally {
      setIsCheckoutLoading(false);
    }
  };

const unlockAfterDelay = () => {
    setTimeout(() => {
      setFirstFeedbackUnlocked(true);
      setOpenTest(false);
    }, 5000);
  };

  const SHARE_MESSAGE = (url) => {
    const position = localStorage.getItem('position') || 'job';
    return `Hey, I just tried this AI mock interviewer called Nora for a ${position} interview and it's actually clutch. You get a free mock interview + full feedback report with my link:\n\n${url}`;
  };

  const buildShareUrl = () => {
    const userId = localStorage.getItem("userId") || "";
    const userName = localStorage.getItem("userName") || "";
    return `https://interview.norahq.com/referral/${userId}/${encodeURIComponent(userName)}`;
  };

  const trackEvent = (event) => {
    try {
      const email = localStorage.getItem('userEmail') || localStorage.getItem('email');
      axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/trackEvent`, { email, event });
    } catch (e) {}
  };

 const handleCopyLink = async () => {
    const url = buildShareUrl();
    try {
      await navigator.clipboard.writeText(SHARE_MESSAGE(url));
      setLinkCopied(true);
      setShareInitiated(true);
      unlockAfterDelay();
      setTimeout(() => setLinkCopied(false), 2500);
    } catch (e) {
      console.error('Copy failed:', e);
    }
  };

  const handleWhatsApp = () => {
    const url = buildShareUrl();
    setShareInitiated(true);
    unlockAfterDelay();
    window.open(`https://wa.me/?text=${encodeURIComponent(SHARE_MESSAGE(url))}`, '_blank');
  };

  const handleUpgrade = async (plan) => {
    if (checkout) {
      try {
        checkout.destroy();
      } catch (error) {
        console.warn('Error destroying previous checkout:', error);
      }
      setCheckout(null);
    }
    
    const checkoutContainer = document.getElementById('checkout');
    if (checkoutContainer) {
      checkoutContainer.innerHTML = '';
    }
    
    setSelectedPlan(plan);
    
    await new Promise(resolve => setTimeout(resolve, 200));
    await initializeEmbeddedCheckout(plan);
  };

  // Function to check subscription after payment
  const checkSubscriptionAfterPayment = async (maxRetries = 20, currentRetry = 0) => {
    try {
      // Set payment processing on first attempt
      if (currentRetry === 0) {
        setPaymentProcessing(true);
        setCheckoutError('');
      }

      const userEmail = localStorage.getItem('userEmail') || localStorage.getItem('email');
      if (!userEmail) {
        setPaymentProcessing(false);
        return;
      }

      const subscriptionCheck = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/checkSubscription`, {
        email: userEmail,
      }, {
        headers: {
          'Content-Type': 'application/json', 
          Accept: 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
      });

      if (subscriptionCheck.data.isSubscribed) {
        setIsSubscribed(true);
        setOpenTest(false);
        setCheckoutError('');
        setPaymentProcessing(false);
        // Force reload of current section to show all content
        setActiveSection(activeSection);
        // Show success message briefly
        console.log('Subscription activated successfully!');
      } else if (currentRetry < maxRetries) {
        // Continue checking every 3 seconds for up to 60 seconds (20 * 3s)
        setTimeout(() => checkSubscriptionAfterPayment(maxRetries, currentRetry + 1), 3000);
      } else {
        // Max retries reached, show error
        // setPaymPayment processing is taking longer than expected. Please refresh the page or contact support.entProcessing(false);
        setCheckoutError('');
      }
    } catch (error) {
      console.error('Error checking subscription after payment:', error);
      if (currentRetry < maxRetries) {
        setTimeout(() => checkSubscriptionAfterPayment(maxRetries, currentRetry + 1), 5000);
      } else {
        setCheckoutError('Unable to verify payment status. Please refresh the page or contact support.');
      }
    }
  };

  // Start checking subscription when checkout is initialized
  useEffect(() => {
    if (checkout && !isSubscribed) {
      checkSubscriptionAfterPayment();
    }
  }, [checkout, isSubscribed]);

  // 3. Start subscription check loop when component mounts
  useEffect(() => {
    const checkSubscriptionLoop = async () => {
      try {
        const userEmail = localStorage.getItem('userEmail') || localStorage.getItem('email');
        if (!userEmail) {
          setIsCheckingSubscription(false);
          // Don't auto-show modal for missing email either
          return;
        }

        const subscriptionCheck = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/checkSubscription`, {
          email: userEmail,
        }, {
          headers: {
            'Content-Type': 'application/json', 
            Accept: 'application/json',
            Authorization: `Bearer ${getToken()}`,
          },
        });

        if (subscriptionCheck.data.isSubscribed) {
          // 3.2 If they have paid, show them everything
          setIsSubscribed(true);
          setIsCheckingSubscription(false);
          setOpenTest(false);
        } else {
          // 3.1 If they have not paid, don't show modal automatically - just set subscription status
          const isReferred = localStorage.getItem("userReferred") === "true";
          setIsSubscribed(false);
          setIsCheckingSubscription(false);
          setOpenTest(!isReferred && !firstFeedbackUnlocked);
          // Don't auto-show modal - user will click "Unlock for More" button
        }

      } catch (error) {
        console.error('Error checking subscription:', error);
        setIsCheckingSubscription(false);
        // Don't auto-show modal on error either
        
        // No retry needed since we're not auto-showing modal anymore
      }
    };

    checkSubscriptionLoop();
  }, []);

  const generatePersonalizedPlan = async () => {
    if (!interviewTimeline) return;
    
    setIsGeneratingPlan(true);
    
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/generateActionPlan`, {
        timeline: interviewTimeline,
        position: feedbackJson?.position,
        jobDescription: localStorage.getItem("jobDescription"),
        companyName: feedbackJson?.companyName,
        resume: localStorage.getItem("resume"),
        history: historyMessage
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
      });
      
      setPersonalizedPlan(response.data.actionPlan);
      setShowGamePlan(true);
      
    } catch (error) {
      console.error('Error generating action plan:', error);
      setPersonalizedPlan("Unable to generate personalized plan. Please try again.");
      setShowGamePlan(true);
    } finally {
      setIsGeneratingPlan(false);
    }
  };

  const sendChatMessage = async (tag, message) => {
    if (!message.trim()) return;
    
    setLoadingChat(prev => [...prev, tag]);

    // Clear input immediately
    setChatInput(prev => ({ ...prev, [tag]: '' }));
    
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/tagChat`, {
        tag: tag,
        userMessage: message,
        position: feedbackJson?.position,
        jobDescription: localStorage.getItem("jobDescription"),
        companyName: feedbackJson?.companyName,
        resume: localStorage.getItem("resume"),
        history: historyMessage,
        chatHistory: chatMessages[tag] || []
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
      });
      
      // Add BOTH user message and Nora's response at once
      setChatMessages(prev => ({
        ...prev,
        [tag]: [...(prev[tag] || []), 
          { role: 'User', message: message }, 
          { role: 'Assistant', message: response.data.response }
        ]
      }));
      
    } catch (error) {
      console.error('Error sending chat message:', error);
      setChatMessages(prev => ({
        ...prev,
        [tag]: [...(prev[tag] || []), 
          { role: 'User', message: message }, 
          { role: 'Assistant', message: "Sorry, I couldn't process your message. Please try again." }
        ]
      }));
    } finally {
      setLoadingChat(prev => prev.filter(t => t !== tag));
    }
  };

  const generateTagFeedback = async (tag) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/generateTagFeedback`, {
        tag: tag,
        position: feedbackJson?.position,
        jobDescription: localStorage.getItem("jobDescription"),
        companyName: feedbackJson?.companyName,
        resume: localStorage.getItem("resume"),
        history: historyMessage
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
      });
      
      return response.data.feedback;
    } catch (error) {
      console.error('Error generating tag feedback:', error);
      return "Unable to generate feedback for this topic. Please try again.";
    }
  };

  const [tagFeedback, setTagFeedback] = useState({});
  const [loadingTags, setLoadingTags] = useState([]);

  const toggleTag = async (tag) => {
    setSelectedTags(prev => {
      if (prev.includes(tag)) {
        return prev.filter(t => t !== tag);
      } else {
        return [...prev, tag];
      }
    });
    
    // Generate feedback if tag is being selected and doesn't have feedback yet
    if (!selectedTags.includes(tag) && !tagFeedback[tag]) {
      setLoadingTags(prev => [...prev, tag]);
      
      const feedback = await generateTagFeedback(tag);
      
      setTagFeedback(prev => ({
        ...prev,
        [tag]: feedback
      }));
      
      setLoadingTags(prev => prev.filter(t => t !== tag));
    }
  };

  const handleAskNora = async () => {
    if (!noraQuestion.trim()) return;
    
    setIsSubmitting(true);
    
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/Chat/askNoraQuestion`, {
        question: noraQuestion,
        position: feedbackJson?.position,
        jobDescription: localStorage.getItem("jobDescription"),
        companyName: feedbackJson?.companyName,
        resume: localStorage.getItem("resume"),
        history: historyMessage
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
      });
      
      // Use the AI-generated tag name
      const generatedTag = response.data.tag;
      
      // Add the new tag to selected tags and store its feedback
      setSelectedTags(prev => [...prev, generatedTag]);
      setTagFeedback(prev => ({
        ...prev,
        [generatedTag]: response.data.feedback
      }));
      
      // Close modal and reset
      setShowAskNoraModal(false);
      setNoraQuestion('');
      
    } catch (error) {
      console.error('Error asking Nora:', error);
      // You could show an error message here
    } finally {
      setIsSubmitting(false);
    }
  };

  // Add this function at the top of your component
  const getSectionDisplay = (section) => {
    switch(section) {
      case "overview":
        return { icon: overviewIcon, text: "Overview" };
      case "transcript":
        return { icon: transcriptsIcon, text: "Transcript" };
      case "tldr":
        return { icon: tldrIcon, text: "TLDR" };
      case "technicalSkills":
        return { icon: technicalSkillsIcon, text: "Technical Skills" };
      case "softSkills":
        return { icon: softSkillsIcon, text: "Soft Skills" };
      case "actionPlan":
        return { icon: nextStepsIcon, text: "Action Plan" };
      default:
        return { icon: overviewIcon, text: "Overview" };
    }
  };

  let navigate = useNavigate();

  const formatDate = (date) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const DateComponent = () => {
    const today = new Date();
    return formatDate(today);
  };

  const navigateToMockInterviewerPage = (companyName, JobDescription, position) => {
    // Check subscription status before navigating
    if (!isSubscribed) {
      setOpenTest(true);
      return;
    }

    navigate('/mockInterviewerInput', {
      state: {
        candidatePosition: position,
        candidateJobDescription: JobDescription,
        candidateCompanyName: companyName,
        candidateResume: localStorage.getItem("resume"),
        candidateResumeFileName: localStorage.getItem("resumeFileName"),
        candidateTechnicalLevel: technicalLevel,
        fromFeedback: true
      }
    });
  };

  // Salary Negotiation Layout (Single Page)
  if (isSalaryNegotiation) {
    return (
      <div className='main-feedback-style'>
      <div className="side-menu2">
        <ul>
          <li onClick={() => {
            setActiveSection("overview");
            window.scrollTo({ top: 0, behavior: 'smooth' }); 
          }}>
            Overview
          </li>

          <li 
            onClick={() => {
                setActiveSection("transcript");
                window.scrollTo({ top: 0, behavior: 'smooth' }); 
            }}
            style={{ 
              cursor: 'pointer',
            }}
          >
            Transcript
          </li>
          
          <li 
            onClick={() => {
                NoraPDFUploader(feedbackJson, timerFeedback, technicalLevel);
            }}
            style={{ 
              cursor: 'pointer',
            }}
          >
            Download Report
          </li>
        </ul>
      </div>
      <div className="content">
        <div className="header-container">
          <h2 className="title-heading">Your Salary Negotiation Report</h2>
        </div>

        {feedbackJson?.position && <h3 className="sub-title">{feedbackJson.position} Position</h3>}
        {timerFeedback && <h3 className="sub-title">{`${timerFeedback} - ${DateComponent()}`}</h3>}

        <div className="select-section">
          <Select
            value={activeSection}
            onChange={(e) => {
              if (e.target.value === "downloadReport") {
                NoraPDFUploader(feedbackJson, timerFeedback);
              } else {
                setActiveSection(e.target.value);
              }
            }}
            disableUnderline
            id="select-style"
          >
            <MenuItem value="overview">Overview</MenuItem>
            <MenuItem value="transcript">
              Transcript
            </MenuItem>
          </Select>
        </div>

        {activeSection === "overview" && (
          <div className="feedback-section">

            <div className="overview-section">

              <div className="summary-section">
                <h4>Overall Performance</h4>
                <p>{feedbackJson?.overallPerformance}</p>
              </div>

              <div className="summary-section">
                <h4>What You Did Well</h4>
                <p>{feedbackJson?.whatTheyDidWell}</p>
              </div>

              <div className="summary-section">
                <h4>Areas for Improvement</h4>
                <p>{feedbackJson?.needsImprovement}</p>
              </div>

              {feedbackJson?.redFlags && feedbackJson.redFlags.toLowerCase() !== "null" && (
                <div className="summary-section">
                  <h4>Red Flags</h4>
                  <p>{feedbackJson?.redFlags}</p>
                </div>
              )}

              <div className="summary-section">
                <h4>Question-by-Question Analysis</h4>
                {feedbackJson?.questionByQuestionAnalysis?.filter(qa => qa && qa.noraStatement && qa.candidateResponse).map((qa, index) => (
                  <div key={index} className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed technical-button" data-bs-toggle="collapse" data-bs-target={`#salary-${index}`}>
                        <div className="d-flex justify-content-between">
                          <span className="text-left">
                            {qa?.noraStatement}
                          </span>
                          <img src={downArrow} className="ml-2" />
                        </div>
                      </button>
                    </h2>
                    <div id={`salary-${index}`} className="accordion-collapse collapse">
                      <div className="accordion-body contact__accordian-body">
                        <p id="dropdown-title">Your Response:</p>
                        <p id="dropdown-paragraph">{qa?.candidateResponse}</p>
                        <p id="dropdown-title">Analysis:</p>
                        <p id="dropdown-paragraph">{qa?.analysis}</p>
                        <p id="dropdown-title">Score: {qa?.score}/10</p>
                        {qa?.betterResponse && qa?.betterResponse !== "null" && (
                          <>
                            <p id="dropdown-title">Better Response:</p>
                            <p id="dropdown-paragraph">{qa?.betterResponse}</p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="summary-section">
                <h4>Salary Negotiation Best Practices</h4>
                <p>To help you succeed in real salary negotiations, here are essential strategies every candidate should master:</p>
                <ul style={{ textAlign: 'left', marginTop: '1.5rem' }}>
                  <li style={{ marginTop: '0.5rem' }}><strong>Research thoroughly:</strong> Know the market rate for your role, experience level, and location before entering any negotiation.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Timing matters:</strong> Wait for a job offer before discussing salary. Let them want you first.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Consider the full package:</strong> Look beyond base salary to include benefits, vacation time, stock options, and professional development opportunities.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Ask open-ended questions:</strong> Use phrases like "What's the salary range for this position?" to gather information without showing your hand.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Give a range, not a number:</strong> When pressed for a number, provide a range with your target salary at the lower end.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Justify your ask:</strong> Back up your requests with specific examples of your value, achievements, and market research.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Be prepared to walk away:</strong> Know your minimum acceptable offer and be willing to decline if it's not met.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Practice active listening:</strong> Pay attention to their concerns and constraints, then address them directly.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Stay professional and positive:</strong> Maintain enthusiasm for the role while advocating for fair compensation.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Get everything in writing:</strong> Once you reach an agreement, ask for the offer details to be documented in writing.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Don't accept immediately:</strong> It's acceptable to ask for 24-48 hours to consider an offer, even if it meets your expectations.</li>
                  <li style={{ marginTop: '0.5rem' }}><strong>Use silence strategically:</strong> After making your case, stay quiet and let them respond first.</li>
                </ul>
              </div>

              <div className="summary-section">
                <h4>Understanding Compensation Structures</h4>
                <p>Before negotiating, understand how different employment types structure compensation:</p>
                
                <div style={{ marginTop: '1.5rem' }}>
                  <h5 style={{ marginBottom: '0.5rem' }}>Internships</h5>
                  <ul style={{ textAlign: 'left', marginTop: '0.5rem' }}>
                    <li><strong>Hourly pay:</strong> Most common structure, typically $15-50+ per hour depending on field and location.</li>
                    <li><strong>Benefits:</strong> Usually minimal - may include basic health insurance for full-time summer internships.</li>
                    <li><strong>Bonuses:</strong> Some companies offer housing stipends or relocation assistance for remote internships.</li>
                  </ul>
                </div>

                <div style={{ marginTop: '1.5rem' }}>
                  <h5 style={{ marginBottom: '0.5rem' }}>Full-Time Positions</h5>
                  <ul style={{ textAlign: 'left', marginTop: '0.5rem' }}>
                    <li><strong>Salary structure:</strong> Annual salary (exempt) vs. hourly with overtime (non-exempt). Exempt = no overtime pay but more flexibility.</li>
                    <li><strong>Equity/Stock:</strong> RSUs (Restricted Stock Units) are common - typically vest over 3-4 years (25% annually). Stock options may have different vesting schedules.</li>
                    <li><strong>Sign-on bonuses:</strong> One-time payments ($5K-$50K+) to offset lost bonuses from previous job or incentivize acceptance.</li>
                    <li><strong>Relocation assistance:</strong> Moving expenses, temporary housing, or lump sum payments for relocating.</li>
                    <li><strong>Health benefits:</strong> Medical, dental, vision insurance - company usually covers 70-100% of premiums.</li>
                    <li><strong>Annual bonuses:</strong> Performance-based, typically 10-25% of base salary depending on company and role.</li>
                    <li><strong>401(k) matching:</strong> Common employer contribution of 3-6% of salary.</li>
                  </ul>
                </div>

                <div style={{ marginTop: '1.5rem' }}>
                  <h5 style={{ marginBottom: '0.5rem' }}>Contract Work</h5>
                  <ul style={{ textAlign: 'left', marginTop: '0.5rem' }}>
                    <li><strong>Higher hourly rates:</strong> Usually 20-40% higher than equivalent full-time hourly to offset lack of benefits.</li>
                    <li><strong>No benefits:</strong> You're responsible for your own health insurance, retirement savings, and taxes.</li>
                    <li><strong>1099 vs. W2:</strong> 1099 = independent contractor (you handle taxes), W2 = employee of contracting agency.</li>
                  </ul>
                </div>
              </div>

              <div className="summary-section">
                <h4>Next Steps</h4>
                <div className="soft-section-border">
                  <div className="soft-section-content">
                    <h4 style={{ fontWeight: 'bold' }}>Practice Again</h4>
                    <p style={{ margin: 0 }}>Redo this salary negotiation to improve upon your approach</p>
                  </div>
                  <button className="start-button" onClick={() => navigateToMockInterviewerPage(localStorage.getItem("companyName"), localStorage.getItem("jobDescription"), localStorage.getItem("position"), technicalLevel)}>
                    Start
                  </button>
                </div>
              </div>

            </div>
          </div>
        )}

        {activeSection === "transcript" && (
          <div className="message-history-feedback">
            <div className="transcript-heading">
              <div><h3 className="transcript-title">Transcript</h3></div>
              <div className="filter-section">
              </div>
            </div>

            {
              filter === "transcript" && (
                <div className="transcript-style">
                  {historyMessage.map((msg, index) => (
                    msg.message !== "first" && msg.message !== "last" && msg.role == "Assistant" && (
                      <div key={index} >
                        <div><strong>Nora:</strong> {msg.message}</div>
                        <br />
                      </div>
                    ) ||
                    msg.message !== "first" && msg.message !== "last" && msg.role == "User" && (
                      <div key={index} >
                        <div><strong>You:</strong> {msg.message}</div>
                        <br />
                      </div>
                    )
                  ))}
                </div>
              )
            }
          </div>
        )}
      </div>
    </div>
    );
  }

  // Regular Interview Layout (Original Multi-Section)
  return (
    <div className='main-feedback-style'>
      <div className="side-menu">
        <ul>
          <li onClick={() => {
            setActiveSection("overview");
            window.scrollTo({ top: 0, behavior: 'smooth' }); 
          }}>
            <img src={overviewIcon} alt="Overview" />
            Overview
          </li>

          <li 
            onClick={() => {
                setActiveSection("transcript");
                window.scrollTo({ top: 0, behavior: 'smooth' }); 
            }}
            style={{ 
              cursor: 'pointer',
            }}
          >
            <img src={transcriptsIcon} alt="Transcript" />
            Transcript
          </li>

          <li 
            onClick={() => {
                setActiveSection("tldr");
                window.scrollTo({ top: 0, behavior: 'smooth' }); 
            }}
            style={{ 
              cursor: 'pointer',
            }}
          >
            <img src={tldrIcon} alt="TLDR" />
            TLDR
          </li>

          <li 
            onClick={() => {
                setActiveSection("technicalSkills");
                window.scrollTo({ top: 0, behavior: 'smooth' }); 
            }}
            style={{ 
              cursor: 'pointer',
            }}
          >
            <img src={technicalSkillsIcon} alt="Technical Skills" />
            Technical Skills
          </li>

          <li 
            onClick={() => {
                setActiveSection("softSkills");
                window.scrollTo({ top: 0, behavior: 'smooth' }); 
            }}
            style={{ 
              cursor: 'pointer',
            }}
          >
            <img src={softSkillsIcon} alt="Soft Skills" />
            Soft Skills
          </li>

          <li 
            onClick={() => {
                setActiveSection("actionPlan");
                window.scrollTo({ top: 0, behavior: 'smooth' }); 
            }}
            style={{ 
              cursor: 'pointer',
            }}
          >
            <img src={nextStepsIcon} alt="Action Plan" />
            Action Plan
          </li>

          <li 
            onClick={() => {
                NoraPDFUploader(feedbackJson, timerFeedback);
            }}
            style={{ 
              marginTop: '20px', 
              borderTop: '1px solid #ddd', 
              paddingTop: '15px',
              cursor: 'pointer',
            }}
          >
            <img src={downloadReportIcon} alt="Download Report" />
            Download Report
          </li>
        </ul>
      </div>
      <div className="content">
        <div className="header-container">
          <h2 className="title-heading">
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '35px', fontSize: '14px', marginTop: '-20px' }}>
              <img src={getSectionDisplay(activeSection).icon} alt="Mock Interview" style={{ width: '24px', height: '24px', marginRight: '10px' }} />
              {getSectionDisplay(activeSection).text}
            </div>
            Your Mock Interview Report
          </h2>
        </div>

        {feedbackJson?.position && <h3 className="sub-title">{feedbackJson.position}</h3>}
        {timerFeedback && <h3 className="sub-title">{`${timerFeedback} - ${DateComponent()}`}</h3>}

        <div className="select-section">
          <Select
            value={activeSection}
            onChange={(e) => {
              if (e.target.value === "downloadReport") {
                NoraPDFUploader(feedbackJson, timerFeedback);
              } else {
                setActiveSection(e.target.value);
              }
            }}
            disableUnderline
            id="select-style"
          >
            <MenuItem value="overview">Overview</MenuItem>
            <MenuItem value="transcript">
              Transcript
            </MenuItem>
            <MenuItem value="tldr">
              TLDR
            </MenuItem>
            <MenuItem value="technicalSkills">
              Technical Skills
            </MenuItem>
            <MenuItem value="softSkills">
              Soft Skills
            </MenuItem>
            <MenuItem value="actionPlan">
              Action Plan
            </MenuItem>
            <MenuItem value="downloadReport">
              Download Report
            </MenuItem>
          </Select>
        </div>

        <div className="divider-line"></div>

        {activeSection === "overview" && (
          <div className="feedback-section">

            <div className="overview-section">
              {feedbackJson?.overallScore && (
                <div className="interview-score-section">
                  <div className="score-container">
                    <span style={{ color: '#5e6468', fontWeight: 'bold' }} className="score-label">Interview Score:</span>
                    <span className="score-badge">
                      {feedbackJson?.overallScore}/100
                    </span>
                  </div>
                  <span className="score-disclaimer">
                    This score is subjective!
                  </span>
                </div>
              )}

              <h3 style={{ color: '#5e6468', fontWeight: 'bold' }}>Recruiter Notes</h3>
              <div className="summary-section">
                <h4>Overview</h4>
                <p>{feedbackJson?.overallSummary}</p>
              </div>
              <div className="skills-section">
                <div className="technical-skills-summary">
                  <h4>Technical Skills</h4>
                  <p>{feedbackJson?.technicalSkillsSummary}</p>
                </div>
                <div className="soft-skills-summary">
                  <h4>Soft Skills</h4>
                  <p>{feedbackJson?.softSkillsSummary}</p>
                </div>
              </div>
            </div>

            {/* PERFORMANCE BREAKDOWN SCORECARDS */}
            {(feedbackJson?.clarityScore || feedbackJson?.friendlinessScore || feedbackJson?.relevanceScore || feedbackJson?.confidenceScore) && (
              <div className="mock-scorecards-section">
                <h3 style={{ color: '#5e6468', fontWeight: 'bold' }}>Interview Performance Breakdown</h3>
                <div className="mock-scorecards-grid">
                  {(feedbackJson?.confidenceScore || feedbackJson?.hesitationScore) && (
                    <ScoreCard
                      title="Confidence & Presence"
                      score={feedbackJson?.confidenceScore || feedbackJson?.hesitationScore}
                      subtitle="How confident and composed you appeared"
                      details={[
                        feedbackJson?.hesitationScore && { label: 'Hesitation Score', value: feedbackJson.hesitationScore },
                      ].filter(Boolean)}
                      description={feedbackJson?.confidenceDescription || 'Processing audio — refresh in a moment.'}
                    />
                  )}
                  {feedbackJson?.clarityScore && (
                    <ScoreCard
                      title="Clarity & Comprehension"
                      score={feedbackJson.clarityScore}
                      subtitle="How clearly you communicated"
                      details={[
                        feedbackJson?.wordsPerMinute && { label: 'Speaking Pace', value: `${feedbackJson.wordsPerMinute} WPM` },
                        feedbackJson?.fillerWordCount != null && { label: 'Filler Words', value: feedbackJson.fillerWordCount },
                      ].filter(Boolean)}
                      description={feedbackJson?.clarityDescription}
                    />
                  )}
                  {feedbackJson?.friendlinessScore && (
                    <ScoreCard
                      title="Friendliness & Warmth"
                      score={feedbackJson.friendlinessScore}
                      subtitle="How personable & engaged you came across"
                      details={[]}
                      description={feedbackJson?.friendlinessDescription}
                    />
                  )}
                  {(feedbackJson?.relevanceScore && feedbackJson?.professionalismScore) && (
                    <ScoreCard
                      title="Content Quality"
                      score={Math.round((Number(feedbackJson.relevanceScore) + Number(feedbackJson.professionalismScore)) / 2)}
                      subtitle="Did you actually answer well and professionally"
                      details={[
                        { label: 'Relevance', value: `${feedbackJson.relevanceScore}/100` },
                        { label: 'Professionalism', value: `${feedbackJson.professionalismScore}/100` },
                      ]}
                      description={feedbackJson?.contentQualityDescription}
                    />
                  )}
                </div>
              </div>
            )}

            <h3 style={{ color: '#5e6468', marginBottom: '1%', fontWeight: 'bold' }}>Our Recommendations</h3>
            <div className="soft-section-border">
              <p style={{ margin: 0 }}>{feedbackJson?.nextSteps}</p>
            </div>
            <h3 style={{ color: '#5e6468', marginBottom: '1%', marginTop: '5%', fontWeight: 'bold' }}>Next Steps</h3>
            <div className="soft-section-border">
              <div className="soft-section-content">
                <h4>1. Redo Interview</h4>
                <p style={{ margin: 0 }}>Redo this interview to improve upon your mistakes</p>
              </div>
              <button className="nora-button-style" onClick={() => navigateToMockInterviewerPage(localStorage.getItem("companyName"), localStorage.getItem("jobDescription"), localStorage.getItem("position"))}>
                Start
              </button>
            </div>
            <div className="soft-section-border">
              <div className="soft-section-content">
                <h4>2. Interview for similar companies</h4>
                <p style={{ margin: 0 }}>Do a mock interview for {localStorage.getItem("position") || feedbackJson?.position} at {companyRecsJson?.company}</p>              
                </div>
              <button className="nora-button-style" onClick={() => navigateToMockInterviewerPage(companyRecsJson?.company, companyRecsJson?.companyJD, localStorage.getItem("position"))}>
                Start
              </button>
            </div>
            <div className="soft-section-border">
              <div className="soft-section-content">
                <h4>3. Interview for similar positions</h4>
                <p style={{ margin: 0 }}>Do a mock interview for {similarPositionJson?.position} at {similarPositionJson?.companyName}</p>
              </div>
              <button className="nora-button-style" onClick={() => navigateToMockInterviewerPage(similarPositionJson?.companyName, similarPositionJson?.jobDescription, similarPositionJson?.position)}>
                Start
              </button>
            </div>

          </div>
        )}

        {activeSection === "transcript" && (
          <div className="message-history-feedback">
            {/* Interview Recording */}
            {recordingLoading && (
              <div style={{ marginBottom: '1rem', color: '#5e6468', fontSize: '0.9rem' }}>
                ⏳ Your interview recording is still processing, it'll appear here shortly...
              </div>
            )}
            {audioRecordingUrl && (audioRecordingUrl.includes('.mp4') || audioRecordingUrl.includes('.webm')) && (
              <div className="recording-section" style={{ marginBottom: '2rem' }}>
                <h4 style={{ color: '#5e6468', fontWeight: 'bold', marginBottom: '1rem' }}>Interview Recording</h4>
                <video 
                  controls 
                  width="100%" 
                  style={{ 
                    maxHeight: '400px', 
                    borderRadius: '8px',
                    backgroundColor: '#000'
                  }}
                >
                  <source src={audioRecordingUrl} type="video/mp4" />
                  <source src={audioRecordingUrl} type="video/webm" />
                  Your browser does not support the video tag.
                </video>
              </div>
            )}
            <div className="transcript-heading">
              <div><h3 className="transcript-title">Transcript</h3></div>
              <div className="filter-section">
              </div>
            </div>

            {
              filter === "transcript" && (
                <div className="transcript-style">
                  {historyMessage.map((msg, index) => (
                    msg.message !== "first" && msg.message !== "last" && msg.role == "Assistant" && (
                      <div key={index} >
                        <div><strong>Nora:</strong> {msg.message}</div>
                        <br />
                      </div>
                    ) ||
                    msg.message !== "first" && msg.message !== "last" && msg.role == "User" && (
                      <div key={index} >
                        <div><strong>You:</strong> {msg.message}</div>
                        <br />
                      </div>
                    )
                  ))}
                </div>
              )
            }
          </div>
        )}

        {activeSection === "tldr" && (
          <div className="tldr-container">
            <div className="tldr-content">
              {/* Left side - AI-generated topics */}
              <div className="tags-section">
                <h4>Nora generated topics</h4>
                <p className="tags-subtitle">Select the topic you wish to explore, and Nora will generate a detailed explanation</p>
                
                {/* Role Specific Tags */}
                {feedbackJson?.actionableTags?.roleSpecific && (
                  <div className="tag-category">
                    <div className="tags-container">
                      {feedbackJson.actionableTags.roleSpecific.map((tag, index) => (
                        <button
                          key={`role-${index}`}
                          className={`tag-pill ${selectedTags.includes(tag) ? 'selected' : ''}`}
                          onClick={() => toggleTag(tag)}
                        >
                          {tag}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                
                {/* Communication Tags */}
                {feedbackJson?.actionableTags?.communication && (
                  <div className="tag-category">
                    <div className="tags-container">
                      {feedbackJson.actionableTags.communication.map((tag, index) => (
                        <button
                          key={`comm-${index}`}
                          className={`tag-pill ${selectedTags.includes(tag) ? 'selected' : ''}`}
                          onClick={() => toggleTag(tag)}
                        >
                          {tag}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                
                {/* Soft Skills Tags */}
                {feedbackJson?.actionableTags?.softSkills && (
                  <div className="tag-category">
                    <div className="tags-container">
                      {feedbackJson.actionableTags.softSkills.map((tag, index) => (
                        <button
                          key={`soft-${index}`}
                          className={`tag-pill ${selectedTags.includes(tag) ? 'selected' : ''}`}
                          onClick={() => toggleTag(tag)}
                        >
                          {tag}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                
                {/* Career Fit Tags */}
                {feedbackJson?.actionableTags?.careerFit && (
                  <div className="tag-category">
                    <div className="tags-container">
                      {feedbackJson.actionableTags.careerFit.map((tag, index) => (
                        <button
                          key={`career-${index}`}
                          className={`tag-pill ${selectedTags.includes(tag) ? 'selected' : ''}`}
                          onClick={() => toggleTag(tag)}
                        >
                          {tag}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                
                <button className="add-topics-btn" onClick={() => setShowAskNoraModal(true)}>
                  + Ask Nora anything about your interview
                </button>
              </div>
              
              {/* Right side - Topic Selected */}
              <div className="topic-selected-section">
                <h4>Topic Selected</h4>
                {selectedTags.length === 0 ? (
                  <div className="no-topic-selected">
                    <div className="search-icon">🔍</div>
                    <h4>No topic selected yet</h4>
                    <p>Select a topic from the left to see its explanation and chat with Nora</p>
                  </div>
                ) : (
                  <div className="selected-feedback">
                    {selectedTags.map(tag => (
                      <div key={tag} className="feedback-item">
                        <h5>{tag}</h5>
                        {loadingTags.includes(tag) ? (
                          <p>Generating feedback...</p>
                        ) : (
                          <p>{tagFeedback[tag] || "Click to generate feedback..."}</p>
                        )}
                        
                        {/* Chat History */}
                        {chatMessages[tag] && chatMessages[tag].length > 0 && (
                          <div className="chat-history">
                            {chatMessages[tag].map((msg, index) => (
                              <div key={index} className={`chat-message ${msg.role.toLowerCase()}`}>
                                <strong>{msg.role === 'User' ? 'You' : 'Nora'}:</strong> {msg.message}
                              </div>
                            ))}
                          </div>
                        )}
                        
                        {/* Loading indicator for chat */}
                        {loadingChat.includes(tag) && (
                          <div className="chat-loading">Nora is typing...</div>
                        )}
                        
                        {/* Chat Input */}
                        <div className="chat-input-container">
                          <input 
                            type="text" 
                            placeholder="Ask Nora a follow up..."
                            className="chat-input"
                            value={chatInput[tag] || ''}
                            onChange={(e) => setChatInput(prev => ({ ...prev, [tag]: e.target.value }))}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                sendChatMessage(tag, chatInput[tag]);
                              }
                            }}
                          />
                          <button 
                            className="send-button"
                            onClick={() => sendChatMessage(tag, chatInput[tag])}
                            disabled={loadingChat.includes(tag)}
                          >
                            Send
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {activeSection === "technicalSkills" && (
          <div className="technical-section">
            <h3 style={{ color: '#5e6468', fontWeight: 'bold' }}>Technical Skills</h3>
            <div className="section">
              <h4>Technical Summary</h4>
              <p>{feedbackJson?.technicalSummary}</p>
            </div>

            <div className="section">
              <h4>Technical Sentiment</h4>
              <p>{feedbackJson?.technicalSentiment}</p>
            </div>

            <div className="section">
              <h4>Technical Question(s) We Asked</h4>
              {feedbackJson?.question
                .filter(qa => qa.categorization.toLowerCase() === "technical")
                .map((qa, index) => (
                  <div key={index} className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed technical-button" data-bs-toggle="collapse" data-bs-target={`#${index}`}>
                        <div className="d-flex justify-content-between">
                          <span className="text-left">
                            {qa?.question}
                          </span>
                          <img src={downArrow} className="ml-2" />
                        </div>
                      </button>
                    </h2>
                    <div id={`${index}`} className="accordion-collapse collapse">
                      <div className="accordion-body  contact__accordian-body">
                        <p id="dropdown-title">Your Answer: </p>
                        <p id="dropdown-paragraph">{qa?.candidateAnswer}</p>
                        <p id="dropdown-title">Our Analysis: </p>
                        <p id="dropdown-paragraph">{qa?.analysis}</p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>

            <div className="section">
              <h4>Interview Suggestions</h4>
              <p>{feedbackJson?.technicalInterviewSuggestions}</p>
            </div>

            <div className="section">
              <h4>Resume/Background Suggestions</h4>
              <p>{feedbackJson?.technicalResumeSuggestions}</p>
            </div>
          </div>
        )}

        {activeSection === "softSkills" && (
          <div className="soft-skill-section">
            <h3 style={{ color: '#5e6468', fontWeight: 'bold' }}>Soft Skills</h3>
            <div className="section">
              <h4>Summary</h4>
              <p>{feedbackJson?.softSkillsSummary}</p>
            </div>
            <div className="section">
              <h4>Behavioral Question(s) We Asked</h4>
              {feedbackJson?.question
                .filter(qa => qa.categorization.toLowerCase() === "soft skill")
                .map((qa, index) => (
                  <div key={index} className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed technical-button" data-bs-toggle="collapse" data-bs-target={`#${index}`}>
                        <div className="d-flex justify-content-between">
                          <span className="text-left">
                            {qa?.question}
                          </span>
                          <img src={downArrow} className="ml-2" />
                        </div>
                      </button>
                    </h2>
                    <div id={`${index}`} className="accordion-collapse collapse">
                      <div className="accordion-body  contact__accordian-body">
                        <p id="dropdown-title">Your Answer: </p>
                        <p id="dropdown-paragraph">{qa?.candidateAnswer}</p>
                        <p id="dropdown-title">Our Analysis: </p>
                        <p id="dropdown-paragraph">{qa?.analysis}</p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>

            <div className="section">
              <h4>Communication Feedback</h4>
              <p>{feedbackJson?.communication}</p>
            </div>

            <div className="section">
              <h4>Time Management Feedback</h4>
              <p>{feedbackJson?.timeManagement}</p>
            </div>
          </div>
        )}

        {activeSection === "actionPlan" && (
          <div className="next-steps-section">
            <h3 style={{ color: '#5e6468', marginBottom: '1%', fontWeight: 'bold' }}>Interview Timeline</h3>
            <h3 style={{ color: '#5e6468', marginBottom: '5%', fontSize: '15px'}}>Choose your interview date to get a personalized game plan.</h3>
            
            <div className="timeline-container">
              <div className="timeline-question">
                <h4 style={{ fontSize: '14px',  marginTop: '3%', color: "#4d5e2f", fontWeight: 'bold' }}>When is your interview?</h4>
                <select 
                  className="timeline-dropdown"
                  value={interviewTimeline}
                  onChange={(e) => setInterviewTimeline(e.target.value)}
                >
                  <option value="">Select timeline...</option>
                  <option value="1-2 days">Within 1-2 days</option>
                  <option value="1-2 weeks">Within 1-2 weeks</option>
                  <option value="1-2 months">Within 1-2 months</option>
                  <option value="3+ months">Within 3+ months</option>
                </select>
                
                {interviewTimeline && (
                  <button 
                    style={{ marginLeft: '15px'}}
                    className="nora-button-style"
                    onClick={generatePersonalizedPlan}
                    disabled={isGeneratingPlan}
                  >
                    {isGeneratingPlan ? 'Generating Plan...' : 'Generate Plan'}
                  </button>
                )}
              </div>
              
              {showGamePlan && personalizedPlan && (
                <div className="game-plan-section">
                  <h4>Your Personalized Action Plan</h4>
                  <div className="personalized-plan-content">
                    {personalizedPlan.split('\n').map((line, index) => (
                      <p key={index} className="plan-line" 
                        dangerouslySetInnerHTML={{ __html: line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Payment Modal */}
        <Modal onClose={() => setOpenTest(false)} open={openTest} disableBackdropClick={true} disableEscapeKeyDown={true}>
          <Box className="custom-modal-box" sx={style2}>
            <h2 className="pricing-title">Unlock feedback & unlimited interviews</h2>
            <p className="pricing-subtitle">
              <span className="pricing-subtext">Subscribe and unlock all your interview insights with Nora</span>
            </p>

            {checkout && (
              <button
                className="pricing-back-btn"
                onClick={() => {
                  if (checkout) {
                    checkout.destroy();
                    setCheckout(null);
                    setCheckoutError('');
                  }
                }}
                aria-label="Go back to plan selection"
              >
                ← Back to Plans
              </button>
            )}

            {!checkout && (
              <div className="pricing-grid">
                <div className={`pricing-card ${selectedPlan === 'monthly' ? 'featured' : ''}`}>
                  <div className="pricing-card__icon"><AutoFixHighIcon /></div>
                  <div className="pricing-card__name">Actually Get Better</div>
                  <div className="pricing-card__separator"></div>
                  <div className="pricing-card__price">
                    <span className="pricing-amount">$15</span>
                    <span className="pricing-period">/mo</span>
                  </div>
                  <div className="pricing-card__desc">Best for consistent practice & growth.</div>
                  <ul className="pricing-list">
                    <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Unlimited mock interviews</li>
                    <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Complete Nora feedback</li>
                    <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Interactive AI coaching chat</li>
                    <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Detailed question analysis</li>
                    <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Personalised action plan</li>
                    <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Cancel your subscription anytime</li>
                  </ul>
                  <button
                    className="pricing-btn solid pricing-btn--monthly"
                    onClick={() => handleUpgrade('monthly')}
                    disabled={isCheckoutLoading}
                  >
                    {isCheckoutLoading && selectedPlan === 'monthly' ? 'Starting…' : 'Upgrade Now'}
                  </button>
                </div>

                <div className={`pricing-card ${selectedPlan === 'annual' ? 'featured' : ''}`}>
                  <div className="pricing-card__top-line">
                    <div className="pricing-card__icon"><FlashOnIcon /></div>
                    <div className="pricing-reco-badge">Recommended</div>
                  </div>
                  <div className="pricing-card__name">Best Value</div>
                  <div className="pricing-card__separator"></div>
                  <div className="pricing-card__price">
                      <span className="pricing-amount">$99</span>
                      <span className="pricing-period">/yr</span>                  
                   </div>
                  <div className="pricing-card__desc">Everything you need to level up, at the best price.</div>
                  <ul className="pricing-list">
                    <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Everything in Pro Monthly</li>
                    <li><span className="pricing-checkmark"><CheckCircleIcon/></span>{"Save over $80/year"}</li>
                    <li><span className="pricing-checkmark"><CheckCircleIcon/></span>Stay motivated with long-term growth</li>
                  </ul>
                  <button
                    className="pricing-btn solid pricing-btn--annual"
                    onClick={() => handleUpgrade('annual')}
                    disabled={isCheckoutLoading}
                  >
                    {isCheckoutLoading && selectedPlan === 'annual' ? 'Starting…' : 'Upgrade Now'}
                  </button>
                </div>
              </div>
            )}

            {!checkout && (
              <div className="pricing-referral">
                {!shareInitiated ? (
                  <div className="pricing-referral-bar">
                    <div className="pricing-referral-bar-text">
                      <strong>Unlock your feedback free</strong><br/>
                      Share Nora with a friend. They'll get their first mock interview + report free, and this paywall will disappear for you right away!
                    </div>
                    <div className="pricing-referral-bar-actions">
                      <button className="pricing-referral-btn-sm" onClick={handleCopyLink}>
                        {linkCopied ? 'Copied!' : 'Copy invite link'}
                      </button>
                      <button className="pricing-referral-link" onClick={handleWhatsApp}>
                        or share on WhatsApp
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="pricing-referral-bar pricing-referral-pending">
                    <div className="pricing-referral-bar-text">
                      <strong>Feedback unlocked 🎉</strong> They get their first report free - yours is ready now!
                    </div>
                  </div>
                )}
              </div>
            )}

            <div
              id="checkout"
              style={{
                display: checkout ? 'block' : 'none',
                minHeight: checkout ? 500 : 0,
                width: '100%',
                marginTop: checkout ? 16 : 0
              }}
            />

            {checkoutError && (
              <div className="pricing-error">{checkoutError}</div>
            )}

          </Box>
        </Modal>

        {showAskNoraModal && (
          <div className="ask-nora-modal">
            <div className="modal-content">
              <h3>Ask Nora</h3>
              <textarea 
                placeholder="Type your question here..."
                value={noraQuestion}
                onChange={(e) => setNoraQuestion(e.target.value)}
              />
              <div className="modal-chat-buttons">
                <button onClick={() => {
                  setShowAskNoraModal(false);
                  setNoraQuestion('');
                }}>
                  Cancel
                </button>
                <button 
                  className="ask-btn"
                  onClick={handleAskNora}
                  disabled={!noraQuestion.trim() || isSubmitting}
                >
                  {isSubmitting ? 'Asking...' : 'Ask Nora'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MockInterviewerFeedback;